import { render, staticRenderFns } from "./ZhanhuiOrgBlock.vue?vue&type=template&id=1d2d3ef3&scoped=true"
import script from "./ZhanhuiOrgBlock.vue?vue&type=script&lang=js"
export * from "./ZhanhuiOrgBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2d3ef3",
  null
  
)

export default component.exports